import { render, staticRenderFns } from "./LocalPriceCreate.vue?vue&type=template&id=0097d811"
import script from "./LocalPriceCreate.vue?vue&type=script&lang=js"
export * from "./LocalPriceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports